import { StarFilled, StarOutlined } from '@ant-design/icons'
import type { PreferredCommunicationType } from '@pkg/form/common'
import { stopEvent } from '@pkg/shared/utils/ui.utils'
import { twMerge } from 'tailwind-merge'

export type FavoriteFieldProps = {
  value?: PreferredCommunicationType | null
  type: PreferredCommunicationType
  onChange?: (type: PreferredCommunicationType) => void
  disabled?: boolean
  className?: string
}

export function FavoriteField(props: FavoriteFieldProps) {
  const { value, type, onChange, disabled, className } = props
  const isFavorite = value === type

  const handleClick = stopEvent(() => {
    if (disabled) return
    onChange?.(type)
  })

  const iconClasses = twMerge(
    'cursor-pointer transition-colors text-lg',
    isFavorite ? 'text-yellow-400' : 'text-gray-300 hover:text-yellow-200',
    disabled && 'cursor-not-allowed opacity-50',
    className,
  )

  if (isFavorite) {
    return <StarFilled className={iconClasses} onClick={handleClick} />
  }

  return <StarOutlined className={iconClasses} onClick={handleClick} />
}
